<div class="wrapper">
  <app-generic-form [data]="data" />
  <app-actions-section [disableAddMenu]="disableAddMenu" class="actions-section w-[455px]" />
</div>
